import axios from "axios";
export function getUsertoken() {
  try {
    let user = localStorage.getItem("accessToken");
    const userToken = user?.replace(/^"+|"+$/g, "").trim();

    return userToken;
  } catch (error) {
    return false;
  }
}
export async function getEmisorData(){
  try {
    const token = getUsertoken();
    const response = await axios.get(`${process.env.VUE_APP_BASE_URL}arca/transacciones/emisor`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
}
